import { render, staticRenderFns } from "./AccountStatementForm.vue?vue&type=template&id=0ee97a88&"
import script from "./AccountStatementForm.vue?vue&type=script&lang=js&"
export * from "./AccountStatementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports